export const getMenuName = (menuOptions, menuId) => {
  const menu = menuOptions.find(m => String(m.id) === String(menuId));
  return menu?.label || menu?.name || menuId;
};

export const buildAssignToastMessage = (
  menuOptions,
  addResults,
  removeResults
) => {
  const addSuccess = addResults.filter(r => r.status === 'fulfilled').length;
  const addFailed = addResults.filter(r => r.status === 'rejected').length;
  const removeSuccess = removeResults.filter(
    r => r.status === 'fulfilled'
  ).length;
  const removeFailed = removeResults.filter(
    r => r.status === 'rejected'
  ).length;

  const totalSuccess = addSuccess + removeSuccess;
  const totalFailed = addFailed + removeFailed;

  if (totalFailed === 0) {
    return `Success: ${addSuccess} assigned, ${removeSuccess} removed`;
  }

  const errorDetails = [];

  addResults
    .filter(r => r.status === 'rejected')
    .forEach(r =>
      errorDetails.push(`assign menu ${getMenuName(menuOptions, r.menuId)}`)
    );

  removeResults
    .filter(r => r.status === 'rejected')
    .forEach(r =>
      errorDetails.push(`remove menu ${getMenuName(menuOptions, r.menuId)}`)
    );

  return `success ${totalSuccess} with error ${totalFailed} (${errorDetails.join(', ')})`;
};

export const buildRightsToastMessage = (menuOptions, results) => {
  const success = results.filter(r => r.status === 'fulfilled').length;
  const failed = results.filter(r => r.status === 'rejected').length;

  if (failed === 0) {
    return `Success: ${success} permission(s) updated`;
  }

  const errorDetails = results
    .filter(r => r.status === 'rejected')
    .map(r => getMenuName(menuOptions, r.menuId));

  return `success ${success} with error ${failed} (${errorDetails.join(', ')})`;
};

export const normalizeMenuRoleItem = item => ({
  id: item.id,
  menuId: String(item.menuId),
  canCreate: item.canCreate ?? true,
  canRead: item.canRead ?? true,
  canUpdate: item.canUpdate ?? true,
  canDelete: item.canDelete ?? true,
});

export const hasRightsChanged = (current, original) =>
  current.canCreate !== original.canCreate ||
  current.canRead !== original.canRead ||
  current.canUpdate !== original.canUpdate ||
  current.canDelete !== original.canDelete;
